import React, { useCallback, useState } from "react";

import { graphql } from "gatsby";
import {
  CheetahEventHandler,
  useCheetahIFrameEvents,
} from "../hooks/useCheetahIFrameEvents";

export default function CheetahEmbed({
  cheetahSrcId,
  ngxFrameId,
}: {
  cheetahSrcId: string;
  ngxFrameId: string;
}) {
  // It's notoriously difficult to set the correct height of iframes. We can achieve
  // this by listening for messages from the iframe when it resizes.
  // Setting an initial height prevents CLS.
  const [height, setHeight] = useState(1331);
  const handler = useCallback<CheetahEventHandler>((event) => {
    if (event.action === "resize" && event.event === "frame:resize") {
      setHeight(event.payload.height);
    }
  }, []);

  useCheetahIFrameEvents(handler);

  return (
    <iframe
      className="min-h-screen"
      data-cy="cheetah-iframe"
      data-testid="cheetah-iframe"
      height={height}
      id={ngxFrameId}
      src={`https://xd.wayin.com/display/container/dc/${cheetahSrcId}/?mode=responsive&scrolling=no`}
      title={"cheetah-embed"}
      width="100%"
    />
  );
}

export const fragment = graphql`
  fragment CheetahEmbedData on CheetahEmbed {
    id
    cheetahSrcId
    ngxFrameId
  }
`;
